import React, { useState } from "react";
import { Mic, Sparkles, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Voice capture button (MOCKED).
 * Subtle, minimal styling with pulsing recording state.
 */
export function VoiceCaptureButton({
  onComplete,
  duration = 3000,
  label = "Capture voice",
  helper = "Tap to speak — mocked",
  size = "lg",
  testId = "voice-capture-btn",
}) {
  const [state, setState] = useState("idle");

  const handleClick = () => {
    if (state !== "idle") return;
    setState("recording");
    setTimeout(() => {
      setState("processing");
      setTimeout(() => {
        setState("idle");
        onComplete && onComplete();
      }, 500);
    }, duration);
  };

  const dim = size === "sm" ? "w-11 h-11" : "w-14 h-14";
  const iconSize = size === "sm" ? "w-4 h-4" : "w-5 h-5";

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="relative">
        {state === "recording" && (
          <>
            <span className="absolute inset-0 rounded-full bg-rose-500/30 recording-ping" />
            <span
              className="absolute inset-0 rounded-full bg-rose-500/25 recording-ping"
              style={{ animationDelay: "0.4s" }}
            />
          </>
        )}
        <button
          onClick={handleClick}
          data-testid={testId}
          disabled={state !== "idle"}
          className={cn(
            "relative rounded-full flex items-center justify-center transition-all duration-300 shadow-sm border",
            dim,
            state === "recording"
              ? "bg-rose-600 text-white border-rose-500 ring-4 ring-rose-500/20"
              : state === "processing"
              ? "bg-foreground text-background border-foreground"
              : "bg-card text-foreground border-border hover:bg-secondary"
          )}
          aria-label={label}
        >
          {state === "processing" ? (
            <Loader2 className={cn(iconSize, "animate-spin")} />
          ) : (
            <Mic className={iconSize} />
          )}
        </button>
      </div>
      <div className="text-center">
        <div className="text-sm font-medium text-foreground flex items-center gap-1.5 justify-center">
          {state === "recording" ? (
            <>
              <span className="w-2 h-2 rounded-full bg-rose-500 animate-pulse" />
              Recording…
            </>
          ) : state === "processing" ? (
            <>
              <Sparkles className="w-3.5 h-3.5" /> Processing…
            </>
          ) : (
            label
          )}
        </div>
        {state === "idle" && helper && (
          <div className="text-[11px] text-muted-foreground mt-0.5 max-w-xs">{helper}</div>
        )}
      </div>
    </div>
  );
}
